import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthenticationState } from './reducer/authentication.reducer';

export const authenticationStateKey = 'authentication';

const authenticationState = createFeatureSelector<AuthenticationState>(authenticationStateKey);

export const selectAuthenticationState = createSelector(authenticationState, (state) => state);
